import React from "react";
import { TextField } from "@c4c-web/ui";
import type { IUseAddressFormStates } from "../../../hooks";
import type { IFormFieldsProps } from "./AddressFormFields";

interface IKuwaitFormFieldsProps extends IFormFieldsProps {
  addressFormStates: IUseAddressFormStates;
}

export const KuwaitFormFields: React.FC<IKuwaitFormFieldsProps> = ({
  addressFormStates,
  errors,
  formData,
  register,
  t,
}) => {
  return (
    <div className="flex flex-col gap-sm">
      <div>
        <TextField
          defaultValue={formData?.number}
          id="number"
          label={t("addressJourney.addressForm.number")}
          {...register("number", { required: true })}
          error={Boolean(
            errors.number || addressFormStates.errorStates.numberError,
          )}
          haveBoldText
          helperText={
            addressFormStates.errorStates.numberError
              ? addressFormStates.errorStates.numberError
              : ""
          }
          placeholder={t("addressJourney.addressForm.placeHolders.number")}
        />
      </div>
      <div>
        <TextField
          defaultValue={formData?.floor}
          id="floor"
          label={t("addressJourney.addressForm.floor")}
          {...register("floor", { required: true })}
          error={Boolean(
            errors.floor || addressFormStates.errorStates.floorError,
          )}
          haveBoldText
          helperText={
            addressFormStates.errorStates.floorError
              ? addressFormStates.errorStates.floorError
              : ""
          }
          placeholder={t("addressJourney.addressForm.placeHolders.floor")}
        />
      </div>
      <div>
        <TextField
          defaultValue={formData?.building}
          id="building"
          label={t("addressJourney.addressForm.building")}
          {...register("building", { required: true })}
          error={Boolean(errors.building)}
          haveBoldText
          helperText={errors.building ? t("addressJourney.error.building") : ""}
          placeholder={t("addressJourney.addressForm.placeHolders.building")}
        />
      </div>
      <div>
        <TextField
          defaultValue={formData?.streetName}
          id="street"
          label={t("addressJourney.addressForm.street")}
          {...register("streetName", { required: true })}
          error={Boolean(errors.streetName)}
          haveBoldText
          helperText={errors.streetName ? t("addressJourney.error.street") : ""}
          placeholder={t("addressJourney.addressForm.placeHolders.street")}
        />
      </div>
      <div>
        <TextField
          defaultValue={formData?.block}
          id="block"
          label={t("addressJourney.addressForm.block")}
          {...register("block", { required: true })}
          error={Boolean(errors.block)}
          haveBoldText
          helperText={errors.block ? t("addressJourney.error.block") : ""}
          placeholder={t("addressJourney.addressForm.placeHolders.block")}
        />
      </div>
    </div>
  );
};
